/**
 * Tax-related constants for GST compliance
 * As per Indian GST regulations
 */

export const GST_RATES = {
  ZERO: 0,
  FIVE: 5,
  TWELVE: 12,
  EIGHTEEN: 18,
  TWENTY_EIGHT: 28,
} as const;

export const DEFAULT_GST_RATE = GST_RATES.EIGHTEEN;

export const VALID_GST_RATES = Object.values(GST_RATES);

/**
 * Check if a GST rate is valid
 */
export const isValidGSTRate = (rate: number): rate is 0 | 5 | 12 | 18 | 28 => {
  return [0, 5, 12, 18, 28].includes(rate);
};

/**
 * GST calculation type based on state
 */
export enum GSTType {
  INTRA_STATE = 'INTRA_STATE', // CGST + SGST
  INTER_STATE = 'INTER_STATE', // IGST
}

/**
 * Invoice status display configuration
 */
export const INVOICE_STATUS_CONFIG = {
  draft: { color: 'default', label: 'Draft' },
  sent: { color: 'info', label: 'Sent' },
  paid: { color: 'success', label: 'Paid' },
  partial: { color: 'warning', label: 'Partially Paid' },
  overdue: { color: 'error', label: 'Overdue' },
  cancelled: { color: 'error', label: 'Cancelled' },
} as const;
